import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/register`;

export default {
  register(payload) {
    return Client.post(`${resource}`, payload);
  },
  checkUnique(payload) {
    return Client.post(`${resource}/check/email`, payload);
  },
  resend(payload) {
    return Client.post(`${resource}/resend`, payload);
  },
  verify(payload) {
    return Client.post(`${resource}/verify`, payload);
  },
  registerInvitation(payload) {
    return Client.post(`${resource}/invite`, payload);
  },
  verifyInvitation(payload) {
    return Client.post(`${resource}/invite/check`, payload);
  }
};
